import { ChatBulkAuditDefaultFilters } from '@scale/shared/defaults';

export const AUDIT_LEVELS_TO_ADD = [
  { level: -1, filter: ChatBulkAuditDefaultFilters.RECENT_L_NEG_1_ATTEMPTS },
  { level: 0, filter: ChatBulkAuditDefaultFilters.RECENT_L0_ATTEMPTS },
  { level: 4, filter: ChatBulkAuditDefaultFilters.RECENT_L4_ATTEMPTS },
  { level: 10, filter: ChatBulkAuditDefaultFilters.RECENT_L10_ATTEMPTS },
  { level: 12, filter: ChatBulkAuditDefaultFilters.RECENT_L12_ATTEMPTS },
];
